
import React from 'react';

import NumericInput, { NumericInputProps } from 'react-numeric-input';

import { WsSalesOrganizationType } from '../../../enums';




// declare namespace NumericInput {

//   interface NumericInputProps extends
//     Omit<
//       React.InputHTMLAttributes<HTMLInputElement>,
//       "min" | "max" | "step" | "onChange" | "defaultValue" | "onInvalid" | "style"
//     >
//   {
//     addLabelText?: string | undefined;
//     componentClass?: string | undefined;
//       defaultValue?: number | string | undefined;
//   }
// }




export type WsNumberFieldProps = {
  organization: WsSalesOrganizationType;
};




const WsNumberField: React.FC<WsNumberFieldProps & NumericInputProps> = props => {

  const { organization, ...numericInputProps } = props;

  return (<NumericInput {...numericInputProps} />);
};




export {
  WsNumberField
};
